import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const NUMS = ["01", "02", "03", "04"];

export default function HowItWorks() {
  const { t } = useLanguage();
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="relative py-24 md:py-32 bg-ink-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-4">{t.how.eyebrow}</div>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl text-white leading-[0.95] break-words">
            {t.how.headingStart} <span className="text-gold">{t.how.headingEnd}</span>
          </h2>
        </div>

        <div className="mt-16 relative">
          <div
            aria-hidden
            className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {t.how.steps.map((s, i) => (
              <motion.div
                key={s.title}
                data-testid={`step-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.15 }}
                className="relative"
              >
                <div className="flex lg:flex-col items-start gap-5 lg:gap-0">
                  <div className="relative shrink-0">
                    <div className="w-20 h-20 rounded-full bg-ink border-2 border-gold flex items-center justify-center font-heading text-4xl text-gold">
                      {NUMS[i]}
                    </div>
                    <div className="absolute inset-0 rounded-full bg-gold/20 blur-xl -z-10" />
                  </div>
                  <div className="lg:mt-8">
                    <h3 className="font-heading text-2xl md:text-3xl text-white uppercase tracking-wide">{s.title}</h3>
                    <p className="mt-3 text-white/60 text-sm md:text-base leading-relaxed max-w-xs">{s.desc}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
